<script>
import { mapGetters, mapActions } from 'vuex'

import { apiSecond } from '@/boot/axios'

import MainFilters from '@/components/MainFilters.vue'

export default {
	name: 'GrownIndex',
	components: {
		MainFilters,
	},
	data() {
		return {
			applications: [],
			totalItems: 0,
			options: {
				itemsPerPage: 10,
				page: 1,
			},
			headers: [
				{ text: 'Id', value: 'id', width: '80px' },
				{ text: this.$t('headers.catch_date'), value: 'name', width: '25vw' },
				{ text: this.$t('headers.created_at'), value: 'created_at' },
				{ text: this.$t('headers.report_status'), value: 'status' },
				{
					text: this.$t('headers.action'),
					value: 'action',
					align: 'left',
					sortable: false,
					width: '200px',
				},
			],
			total: 0,
			errorMessage: {
				status: null,
				text: null,
			},
			message: {
				status: null,
				text: null,
			},
			loading: false,
		}
	},
	computed: {
		...mapGetters(['_getFishes', '_getUserObject']),
		isMagazinsCanEdit() {
			return (magazin) => {
				return magazin.status !== 'active'
			}
		},
		isUserReady() {
			return this.userObject && this.userObject.id
		},
		getHeaders() {
			return [
				...this.headers,
				...this._getFishes
					.filter((fish) => {
						return this.applications.some((item) => {
							return (
								item.fishs &&
								item.fishs.some((f) => {
									return f.fish_id === fish.id
								})
							)
						})
					})
					.map((fish) => {
						return {
							text: fish.name,
							value: 'fish',
							fish_id: fish.id,
							width: '150px',
							sortable: false,
						}
					}),
			]
		},
		userObject() {
			return this.$store.state.userObject
		},
	},
	methods: {
		...mapActions(['_fetchFishes']),
		search() {
			this.apiGetList()
			this.getTotalID()
		},
		findFish(fishs, id) {
			if (!fishs || !Array.isArray(fishs)) return 0
			return this.$options.filters.formatNumber(
				fishs.find((fish) => fish.fish_id == id)?.value || 0,
			)
		},
		pagination(options) {
			this.apiGetList(options.page, options.itemsPerPage, options)
		},
		getQueries() {
			let queries = ''
			if (this.$route.query.status) queries += '&status=' + this.$route.query.status
			if (this.$route.query.start_at) queries += '&start_at=' + this.$route.query.start_at
			if (this.$route.query.finish_at) queries += '&end_at=' + this.$route.query.finish_at
			if (this.$route.query.reservoirs) {
				this.$route.query.reservoirs.forEach((reservoir) => {
					queries += '&reservoirs[]=' + reservoir
				})
			}

			return queries
		},
		apiGetList(page = 1, itemsPerPage = 10, options) {
			if (!this.isUserReady) {
				return
			}

			this.loading = true

			const queriesString = this.getQueries()
			let queries =
				`user_id=${this.userObject.id}&page=${page}&per_page=${itemsPerPage}` +
				(queriesString ? '&' + queriesString : '')

			if (options?.sortBy?.length) {
				queries += `&sort[${options.sortBy[0]}]=${
					!options.sortDesc?.length || !options.sortDesc[0] ? 'asc' : 'desc'
				}`
			}

			apiSecond
				.get(`v1/grown/list?${queries}`)
				.then((response) => {
					if (response.data) {
						this.applications = response.data.data
						this.totalItems = response.data.total
						this.options.page = response.data.current_page || 1
						this.options.itemsPerPage = parseInt(response.data.per_page) || 10
					}
				})
				.catch((error) => {
					if (error?.response?.status == 500) {
						this.errorMessage.status = 500
						this.errorMessage.text = this.$t('system_message.500')
					}
					if (error?.response?.status == 401) {
						this.errorMessage.status = 401
						this.errorMessage.text = error.response.data.error_message
						this.$router.push('/' + this.$i18n.locale + '/login')
					}
					if (error?.response?.status == 422) {
						this.errorMessage.status = 422
						this.errorMessage.text = error.response.data.error_message
					}
					if (error?.response?.status == 403) {
						this.errorMessage.status = 403
						this.errorMessage.text = error?.response?.data?.message
					}
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	beforeCreate() {
		if (!localStorage.token) {
			this.$router.push('/ru/login')
		}
	},
	async mounted() {
		await this._fetchFishes()

		if (this.isUserReady) {
			this.apiGetList()
		} else {
			this.$nextTick(() => {
				if (this.isUserReady) {
					this.apiGetList()
				}
			})
		}
	},
	head: {
		title() {
			return {
				inner: this.$t(`titles.grownJournals`),
			}
		},
		meta: [],
	},
}
</script>

<template>
	<div
		class="wrap__content"
		v-bind:class="{ 'wrap__content--preloader': !applications || !$store.state.userObject }"
	>
		<v-preloader v-if="!$store.state.userObject" :message="errorMessage"></v-preloader>

		<div class="container" v-if="$store.state.userObject">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['GrownManagement', 'TradeManagementMain']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__title--element">
										<div class="content__title--text">{{ $t(`titles.grownJournals`) }}</div>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div class="table__block--content">
									<div class="row">
										<div class="col">
											<div class="flex justify-end mb-2">
												<router-link
													v-if="$store.getters.userPermission(['change_trade'])"
													:to="'/' + $i18n.locale + '/account/logs/grown/create'"
													class="btn--link btn--link--plus"
												>
													{{ $t('labels.record_to_journal') }}
													<img src="@/assets/img/icon-plus.svg" />
												</router-link>
											</div>
										</div>
									</div>

									<MainFilters
										:filter-keys="['reservoirs', 'status', 'start_at', 'finish_at']"
										class="mb-4"
										:filter-options="{
											reservoirs: {
												multiple: true,
												confinesValue: _getUserObject?.quota_ponds,
											},
											brigades: {
												multiple: false,
											},
										}"
										@search="search"
									/>

									<v-data-table
										:headers="getHeaders"
										:items="applications"
										:loading="loading"
										:options.sync="options"
										:server-items-length="totalItems"
										:footer-props="{
											'items-per-page-options': [5, 10, 20, 30, 40, 50],
										}"
										@update:options="pagination"
									>
										<template v-slot:item.name="{ item }">
											<router-link :to="'/' + $i18n.locale + '/account/logs/grown/' + item.id">
												Запись от {{ item.catch_at | formatOnlyDate }}
											</router-link>
										</template>
										<template v-slot:item.created_at="{ item }">
											{{ item.created_at | formatDate }}
										</template>
										<template v-slot:item.status="{ item }">
											<span v-if="item.status" :class="{ 'tb__status--success': item.status == 'active' }">{{
												$t('statusses.readGrownAll.' + item.status)
											}}</span>
											<span v-else> - </span>
										</template>
										<template v-slot:item.action="{ item }">
											<div class="flex">
												<router-link
													:to="'/' + $i18n.locale + '/account/logs/grown/' + item.id"
													class="tb__table--btn tb__table--show"
													v-tooltip.top-center="{
														content: $t('tooltip.look'),
														class: ['tooltip__btn'],
													}"
												>
													<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.75 9s3-6 8.25-6 8.25 6 8.25 6-3 6-8.25 6S.75 9 .75 9z" stroke="#5ABB5E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z" stroke="#5ABB5E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
												</router-link>
											</div>
										</template>
										<v-alert slot="no-results" :value="true" color="error">
											{{ $t('system_message.search') }}
										</v-alert>
									</v-data-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
header .header__row {
	display: flex;
}
</style>
